import React from "react";
import { InnerBannerImg } from "../../constant/Index";
import { useDispatch, useSelector } from "react-redux";

const InnerBanner2 = () => {
	const { NamesList } = useSelector((state) => state.product);
	let currentUrl = window.location.href.split("/");
	return (
		<>
			<section className="universal_banner">
				<div className="container-fluid p-0">
					<div className="banner-content">
						<div className="banner_image">
							<figure>
								<img src={InnerBannerImg} className="img-fluid" />
							</figure>
						</div>
						<div className="page-title">
							<h2 className="title">{NamesList}</h2>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default InnerBanner2;
